export function secondsToStr(temp, locale = "zh-CN") {
  const i18n = {
    "zh-CN": { y: "年", d: "天", h: "小时", m: "分钟", s: "秒" },
    "en-US": { y: "year", d: "day", h: "hour", m: "minute", s: "second" }
  };
  const years = Math.floor(temp / 31536000);
  if (years) {
    return `${years}${i18n[locale].y}` + numberEnding(years);
  }
  const days = Math.floor((temp %= 31536000) / 86400);
  if (days) {
    return `${days}${i18n[locale].d}` + numberEnding(days);
  }
  const hours = Math.floor((temp %= 86400) / 3600);
  if (hours) {
    return `${hours}${i18n[locale].h}` + numberEnding(hours);
  }
  const minutes = Math.floor((temp %= 3600) / 60);
  if (minutes) {
    return `${minutes}${i18n[locale].m}` + numberEnding(minutes);
  }
  const seconds = temp % 60;
  return `${seconds}${i18n[locale].s}` + numberEnding(seconds);

  function numberEnding(number) {
    return number > 1 && locale === "en-US" ? "s" : "";
  }
}

export function kebabCase(s) {
  return s.replace(/[A-Z]/g, m => `-${m.toLowerCase()}`);
}

function isPlainObject(obj) {
  return (
    Object.prototype.toString.call(obj) === "[object Object]" &&
    Object.getPrototypeOf(obj) === Object.prototype
  );
}

export function each(ary, func, context) {
  if (typeof ary.length !== "undefined") {
    for (var i = 0, len = ary.length; i < len; i++) {
      if (func.call(context, ary[i], i, ary) === false) {
        break;
      }
    }
  } else {
    for (var k in ary) {
      if (func.call(context, ary[k], k, ary) === false) {
        break;
      }
    }
  }
}

export function extend() {
  var options;
  var name;
  var src;
  var copy;
  var copyIsArray;
  var clone;
  var target = arguments[0] || {};
  var i = 1;
  var length = arguments.length;
  var force = false;

  if (typeof target === "boolean") {
    force = target;
    target = arguments[1] || {};
    i++;
  }

  if (
    typeof target !== "object" &&
    Object.prototype.toString.call(target) !== "[object Function]"
  ) {
    target = {};
  }

  if (i === length) {
    target = this;
    i--;
  }

  for (; i < length; i++) {
    if ((options = arguments[i]) != null) {
      for (name in options) {
        src = target[name];
        copy = options[name];
        if (target === copy) {
          continue;
        }
        if (
          force &&
          copy &&
          (isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))
        ) {
          if (copyIsArray) {
            copyIsArray = false;
            clone = src && Array.isArray(src) ? src : [];
          } else {
            clone = src && isPlainObject(src) ? src : {};
          }
          target[name] = this.extend(force, clone, copy);
        } else if (copy !== undefined) {
          target[name] = copy;
        }
      }
    }
  }
  return target;
}
